export default {
  tabWidth: 100,
  tabContentMaxWidth: "1100px",
  iconSize: 44
};
